import React, { memo } from 'react';
import { StyleSheet } from 'react-native';
import WalkthroughOverlay from '../WalkthroughOverlay';
const NotificationsListScreenHeaderOverlay = () => (<WalkthroughOverlay context="notifications" style={staticStyles.walkthroughOverlay}/>);
const staticStyles = StyleSheet.create({
    walkthroughOverlay: {
        zIndex: 3,
    },
});
export default memo(NotificationsListScreenHeaderOverlay);
